(function($) {
    'use strict';

    if (typeof window.DOMPurify === 'undefined') {
        console.error('DOMPurify is required for this patch. Please include DOMPurify before this patch.');
        return;
    }

    // Configuration (extendable). Consumers can push selectors at runtime.
    window.jQueryDomPurifyPatchConfig = window.jQueryDomPurifyPatchConfig || {
        // Only these contexts (or with data-sanitize attr) get full user-content sanitization.
        sanitizeSelectors: ['.user-richtext', '.richtext-input', '[data-sanitize]'],
        // Contexts (or with data-skip-sanitize attr) that should bypass sanitization entirely.
        // Extended to skip all jQuery UI datepicker instances and generated containers.
        skipSelectors: ['.channel-mapping-tab', '.bookings-tab', '.layout-internal-page', '#sidebar-calendar', '[data-skip-sanitize]', '.hasDatepicker', '#ui-datepicker-div', '.ui-datepicker', '.ui-datepicker-inline'],
        // Relaxed contexts: internal HTML fragments that may carry <link> / <style> we must preserve.
        relaxedDetectors: [/<(link|style)\b/i, /data-internal-template/, /class="[^"]*(channel-mapping|bookings-list)[^"]*"/i]
    };
    var cfg = window.jQueryDomPurifyPatchConfig;

    function contextMatches($ctx, selectorArray) {
        for (var i = 0; i < selectorArray.length; i++) {
            if ($ctx.is(selectorArray[i]) || $ctx.closest(selectorArray[i]).length) {
                return true;
            }
        }
        return false;
    }

    function isRelaxedTemplate(html) {
        if (!html || typeof html !== 'string') return false;
        for (var i = 0; i < cfg.relaxedDetectors.length; i++) {
            if (cfg.relaxedDetectors[i].test(html)) return true;
        }
        return false;
    }

    function shouldSkip($ctx) {
        return contextMatches($ctx, cfg.skipSelectors);
    }

    function shouldFullSanitize($ctx) {
        return contextMatches($ctx, cfg.sanitizeSelectors) || $ctx.is('[data-sanitize]') || $ctx.closest('[data-sanitize]').length;
    }

    // Decide sanitization mode for a piece of HTML being inserted into $targets
    function applySanitize($targets, html) {
        if (!html || typeof html !== 'string') return html;

        // If any target explicitly skips sanitization OR html is datepicker markup we must preserve (onclick handlers etc.)
        if (($targets && $targets.length && shouldSkip($targets)) || containsDatepickerMarkup(html) || ($targets && $targets.filter('.hasDatepicker').length) || ($targets && $targets.closest('.hasDatepicker').length)) {
            return html; // trust internal datepicker / internal load
        }

        // Internal template heuristic: allow link/style etc, forbid active content only
        if (isRelaxedTemplate(html)) {
            return DOMPurify.sanitize(html, {
                FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
                // keep link/style/meta etc
                KEEP_CONTENT: true,
                RETURN_DOM: false,
                SAFE_FOR_JQUERY: true
            });
        }

        // User-entered content sanitization
        if ($targets && $targets.length && shouldFullSanitize($targets)) {
            return DOMPurify.sanitize(html, {
                SAFE_FOR_JQUERY: true,
                USE_PROFILES: { html: true }
            });
        }

        // Default: relaxed (strip active scripts only, keep formatting)
        return DOMPurify.sanitize(html, {
            FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
            KEEP_CONTENT: true,
            SAFE_FOR_JQUERY: true
        });
    }

    // Store original methods
    var originalHtml = $.fn.html;
    var originalAppend = $.fn.append;
    var originalPrepend = $.fn.prepend;
    var originalBefore = $.fn.before;
    var originalAfter = $.fn.after;
    var originalWrapAll = $.fn.wrapAll;
    var originalWrapInner = $.fn.wrapInner;
    var originalReplaceWith = $.fn.replaceWith;

    // Patch jQuery.parseHTML - cannot know context, so only perform relaxed sanitization (preserve link/style)
    var originalParseHTML = $.parseHTML;
    $.parseHTML = function(html, context, keepScripts) {
        if (html && typeof html === 'string') {
            html = DOMPurify.sanitize(html, {
                FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
                KEEP_CONTENT: true
            });
        }
        return originalParseHTML.call(this, html, context, keepScripts);
    };

    // Patch html() method
    $.fn.html = function(html) {
        if (html === undefined) {
            return originalHtml.call(this);
        }
        html = applySanitize(this, html);
        return originalHtml.call(this, html);
    };

    // Patch DOM insertion methods generically
    function sanitizeArgs($ctx, args) {
        for (var i = 0; i < args.length; i++) {
            if (typeof args[i] === 'string') {
                args[i] = applySanitize($ctx, args[i]);
            }
        }
        return args;
    }

    $.fn.append = function() {
        return originalAppend.apply(this, sanitizeArgs(this, arguments));
    };

    $.fn.prepend = function() {
        return originalPrepend.apply(this, sanitizeArgs(this, arguments));
    };

    $.fn.before = function() {
        return originalBefore.apply(this, sanitizeArgs(this, arguments));
    };

    $.fn.after = function() {
        return originalAfter.apply(this, sanitizeArgs(this, arguments));
    };

    $.fn.wrapAll = function(html) {
        return originalWrapAll.call(this, applySanitize(this, html));
    };

    $.fn.wrapInner = function(html) {
        return originalWrapInner.call(this, applySanitize(this, html));
    };

    $.fn.replaceWith = function(html) {
        return originalReplaceWith.call(this, applySanitize(this, html));
    };

    function containsDatepickerMarkup(html) {
        if (!html || typeof html !== 'string') return false;
        // Detect jQuery UI datepicker generated day cells and inline onclick handlers we must preserve.
        return /(ui-datepicker|hasDatepicker|DP_jQuery_.*\.datepicker|ui-datepicker-calendar)/.test(html);
    }

})(jQuery);